//#region src/products/products.ts
let Product = /* @__PURE__ */ function(Product) {
	Product["NodeApi"] = "node-api";
	Product["NftApi"] = "nft-api";
	Product["SwapsApi"] = "swaps-api";
	Product["BlockTimestampApi"] = "block-timestamp-api";
	Product["TokenApi"] = "token-api";
	Product["TransfersApi"] = "transfers-api";
	Product["BundlerApi"] = "bundler-api";
	Product["DebugApi"] = "debug-api";
	Product["EmbeddedAccounts"] = "embedded-accounts";
	Product["GasManagerApi"] = "gas-manager-api";
	Product["TraceApi"] = "trace-api";
	Product["PricesApi"] = "prices-api";
	Product["TransactionSimulationApi"] = "transaction-simulation-api";
	Product["TransactionReceiptsApi"] = "transaction-receipts-api";
	Product["UserOperationsApi"] = "user-operations-api";
	Product["Websockets"] = "smart-websockets";
	Product["Webhooks"] = "webhooks";
	Product["Grpc"] = "grpc";
	return Product;
}({});
//#endregion
export { Product };

//# sourceMappingURL=products.js.map